import { ServiceResult } from '../models';
import {
  CopyRecipeMenuHeaderRequest,
  CreateRecipeMenuHeaderRequest,
  DeleteRecipeMenuHeaderRequest,
  RecipeMenuHeader,
  UpdateRecipeMenuHeaderRequest,
} from '../models/recipe-menu-header.models';

import ApiService from './api-service';

class RecipeMenuHeaderService extends ApiService {
  private static classInstance: RecipeMenuHeaderService;

  private constructor() {
    super('RecipeMenuHeader');
  }

  public static getInstance(): RecipeMenuHeaderService {
    if (!this.classInstance) {
      this.classInstance = new RecipeMenuHeaderService();
    }
    return this.classInstance;
  }

  public getRecipeMenuHeader(customerId: string, recipeMenuHeaderId: string): ServiceResult<RecipeMenuHeader> {
    return this.get(
      `${this.baseUrl}/GetRecipeMenuHeader?customerId=${customerId}&recipeMenuHeaderId=${recipeMenuHeaderId}`
    );
  }

  public getRecipeMenuHeaders(customerId: string): ServiceResult<RecipeMenuHeader[]> {
    return this.get(`${this.baseUrl}/GetRecipeMenuHeaders?customerId=${customerId}`);
  }

  public createRecipeMenuHeader(request: CreateRecipeMenuHeaderRequest): ServiceResult<RecipeMenuHeader> {
    return this.post(`${this.baseUrl}/CreateRecipeMenuHeader`, request);
  }

  public updateRecipeMenuHeader(request: UpdateRecipeMenuHeaderRequest): ServiceResult<RecipeMenuHeader> {
    return this.post(`${this.baseUrl}/UpdateRecipeMenuHeader`, request);
  }

  public copyRecipeMenuHeader(request: CopyRecipeMenuHeaderRequest): ServiceResult<RecipeMenuHeader> {
    return this.post(`${this.baseUrl}/CopyRecipeMenuHeader`, request);
  }

  public deleteRecipeMenuHeader(request: DeleteRecipeMenuHeaderRequest): ServiceResult<undefined> {
    return this.post(`${this.baseUrl}/DeleteRecipeMenuHeader`, request);
  }
}

export default RecipeMenuHeaderService;
